import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import CheckIcon from '@mui/icons-material/Check'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { map, reduce } from 'lodash'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

interface Props {
    setPage: () => void
}

const DefaultFilters = (t) => [
    {
        title: t('finances.writeOffs'),
        value: 'spent',
    },
    {
        title: t('finances.replenishments'),
        value: 'add',
    },
]

export const TypeFilter: React.FC<Props> = ({ setPage }) => {
    const { t } = useTranslation()
    const filters = DefaultFilters(t)
    const [orderBy, setOrderBy] = useState('spent')
    const [searchParams, setSearchParams] = useSearchParams()

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

    const filtersConfig = reduce(
        filters,
        (acc, { value, title }) => ({ ...acc, [value]: title }),
        {},
    )

    const open = Boolean(anchorEl)

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleChange = (value) => {
        setOrderBy(value)
        setAnchorEl(null)
        setPage(0)
    }

    useEffect(() => {
        searchParams.set('order_by', orderBy)
        setSearchParams(searchParams)
    }, [orderBy])

    return (
        <Grid
            sx={{
                display: 'flex',
            }}>
            <Button
                sx={{ color: '#5A5F72', padding: '16px' }}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="text"
                disableElevation
                onClick={handleClick}
                endIcon={<ArrowDropDownIcon />}>
                {filtersConfig[orderBy]}
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {map(filters, (item) => {
                    return (
                        <MenuItem
                            value={item.value}
                            onClick={() => handleChange(item.value)}
                            sx={{ pl: 3, background: item.value === orderBy ? '#F4F4F6' : '#fff' }}>
                            {item.value === orderBy ? (
                                <CheckIcon
                                    sx={{ fontSize: '12px', position: 'absolute', left: '8px' }}
                                />
                            ) : null}
                            {item.title}
                        </MenuItem>
                    )
                })}
            </Menu>
        </Grid>
    )
}
